import { post, get, del } from '../../xhr/fetch'
import { OPERATION_CENTER_PREFIX } from '../../config'

// 账户列表
export const GET_ACCOUNT_LIST = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/org/v1/queryOrgInfo`, data)
}

// 机构下拉框
export const GET_INSTITUTION_LIST = () => {
  return get(`${OPERATION_CENTER_PREFIX}/common/v1/select/org`)
}

// 根据机构获取机构下的门店
export const GET_STORE_LIST_BY_INSTITUTION = (orgId) => {
  return get(`${OPERATION_CENTER_PREFIX}/common/v1/select/store/${orgId}`)
}

// 内容下拉框
export const GET_CONTENT_LIST = () => {
  return get(`${OPERATION_CENTER_PREFIX}/common/v1/select/app`)
}

// 新增账户
export const ADD_ACCOUNT = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/org/v1/saveOrgInfo`, data)
}

// 删除账户
export const DEL_ACCOUNT = (data) => {
  return del(`${OPERATION_CENTER_PREFIX}/org/v1`, data)
}

// 查看账户
export const GET_ACCOUNT_DETAIL = (id) => {
  return get(`${OPERATION_CENTER_PREFIX}/org/v1/${id}`)
}

// 更新账户
export const UPDATE_ACCOUNT = (data) => {
  return post(`${OPERATION_CENTER_PREFIX}/org/v1/updateOrgInfo`, data)
}
